import React, { useState, useContext, useEffect } from 'react';
import axiosConfig from '../../../../../utils/axiosConfig';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './NewsfeedModalForm.css';

import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography
} from '@material-ui/core';

import { StateContext, DispatchContext } from '../../../../../context/Provider';

const editorConfiguration = {
    toolbar: {
        items: [
            'heading', '|', 
            'bold', 'italic',
            'link', 'bulletedList', 'numberedList', '|',
            'outdent', 'indent', '|',
            'blockQuote', 'insertTable', '|',
            'undo', 'redo'
        ],
        viewportTopOffset: 30,
        shouldNotGroupWhenFull: true
    },
    mediaEmbed: {
        previewsInData: true
    }
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NewsfeedModalForm = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalState, facultyState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [announcement, setAnnouncement] = useState({
        id: '',
        description: ''
    });

    async function updateAnnouncement(values, resetForm) {
        const res = await axiosConfig.post(`/announcements/${props.announcementID}`, {
            _method: 'PATCH',
            description: announcement.description
            // description: values.description
        });

        if (res.data.status_code == 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'Announcement updated successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchAnnouncements();
            props.handleClose();
        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    useEffect(() => {
        if (props.announcementID) {
            setAnnouncement({
                id: props.announcementID,
                description: props.description
            });
        }
    }, [props.announcementID]);

    return (
        <Dialog 
            open={props.open} 
            onClose={props.handleClose} 
            aria-labelledby="form-dialog-title"
            fullWidth={true} 
            maxWidth={'md'}
            TransitionComponent={Transition}
            disableBackdropClick 
        >
            <Formik
                initialValues={announcement}
                validate={(values) => {
                    const errors = {};

                    // if (!values.description) {
                    //     errors.description = 'This field is required';
                    // }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {

                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});
                    updateAnnouncement(values, resetForm);
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <DialogTitle id="form-dialog-title">
                            {props.dialogTitle}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container>
                                <Grid item xs={12}>
                                    {/* <Field
                                        component={TextField}
                                        label="Description (required)"
                                        name="description"
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                    /> */}

                                    <Box style={{overflowX: 'hidden'}}>
                                        <CKEditor
                                            editor={ ClassicEditor }
                                            config={ editorConfiguration }
                                            data={announcement.description}
                                            onReady={ editor => {
                                                // You can store the "editor" and use when it is needed.
                                                // console.log( 'Editor is ready to use!', editor );
                                            }}
                                            onChange={ ( event, editor ) => {
                                                const data = editor.getData();
                                                let announcementCopy = JSON.parse(JSON.stringify(announcement));
                                                announcementCopy.description = data;
                                                setAnnouncement(announcementCopy);
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={props.handleClose} 
                                disabled={isSubmitting} 
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button 
                                disabled={isSubmitting} 
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

export default NewsfeedModalForm;